import React from "react";
import clsx from "clsx";
import { ReactComponent as AlertIcon } from "common-assets/assets/icons/alert.svg";
import { FormHelperText } from "@material-ui/core";
import { FieldErrorMessageModel } from "./tools/FieldErrorMessage.model";
import { Typography } from "../../Typography/Typography";

import useStyles from "./FieldErrorMessage.style";

export const FieldErrorMessage= ({
  children,
  className,
  id,
  ariaLive = "assertive",
  testId = 'FieldErrorMessage',
  component: Component = 'div',
}: FieldErrorMessageModel) => {
  const c = useStyles({});

  return (
    <FormHelperText
      className={clsx(c.root, className, "FieldErrorMessage")}
      id={id}
      aria-live={ariaLive}
      data-type="ui/FieldErrorMessage"
      data-testid={testId}
      error={true}
      component={Component}
    >
      <AlertIcon aria-hidden="true" focusable="false" className={c.icon}/>
      <Typography variant="body2" component="span" className={c.errorMessage} testId="FieldErrorMessage-text">{children}</Typography>
    </FormHelperText>
  );
};
